import { css } from '@emotion/react';
import { forwardRef } from 'react';
import type { Theme } from '~/_shared/themes/theme.model';
import { zIndexGeneral } from '../../constants/zIndexGeneral.enum';

type OverlayProps = Readonly<{
  className?: string;
  children?: React.ReactNode;
}>;

const overlayStyle = (theme: Theme) => css({
  position: 'absolute',
  inset: 0,
  background: theme.backgroundColors.overlay,
  zIndex: zIndexGeneral.OverlayLayer,
});

export const OverlayComponent = forwardRef<HTMLDivElement, OverlayProps>((props, ref) => {
  return (
    <div
      ref={ref}
      className={props.className}
      css={overlayStyle}
    >
      {props.children}
    </div>
  );
});
